
<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">仓库详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="仓库名称" prop="name" style="display:inline-block;">
          <el-input v-model="ruleForm.name" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="responsiblePerson" style="display:inline-block;">
          <el-input v-model="ruleForm.responsiblePerson" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="移动电话" prop="mobileNo" style="display:inline-block;">
          <el-input v-model="ruleForm.mobileNo" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="物资所属企业" prop="belongEnterprise" style="display:inline-block;">
          <el-input v-model="ruleForm.belongEnterprise" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="仓库面积" prop="warehouseArea" style="display:inline-block;">
          <el-input v-model="ruleForm.warehouseArea" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="仓库地址" prop="address" style="display:inline-block;">
          <el-input v-model="ruleForm.address" style="width:118rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="longitude" style="display:inline-block;">
          <el-input v-model="ruleForm.longitude" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latitude" style="display:inline-block;">
          <el-input v-model="ruleForm.latitude" style="width:45rem;" v-bind:disabled="IsEdit"></el-input>
          <ZjLngLatSelect
            :point_lat="ruleForm.latitude"
            :point_lng="ruleForm.longitude"
            @onGotLngLat="onGotLngLat"
            :disabled="IsEdit"
            title="地图定位"
            style="margin-left:0.8rem;"
          ></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="display:inline-block;">
          <el-input
            type="textwarehouseArea"
            style="width:118rem;"
            v-model="ruleForm.remark"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form></div>
    </zj-layout-main>
    <zj-layout-footer>
      <div class="right" style="width:134rem; text-align:center;margin:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
  
</template>
<script>
import { warehouseSave, warehouseUpdate, warehouseDetail } from '@/api/src/emergency_warehouse'
export default {
  name: "ZjMaterialWarehouseinfo",
  controller: "UI",
  action: "MaterialWarehouseinfo",
  props: {
    query: {
      type: String,
      id: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      ruleForm: {
        name: "",
        responsiblePerson: "",
        mobileNo: "",
        belongEnterprise: "",
        warehouseArea: null,
        address: "",
        longitude: "",
        latitude: "",
        remark: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 15 个字符", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请选择仓库地址", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        longitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        latitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        IsEdit: false
      }
    };
  },
  created: function() {
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      handler: function(val, oldVal) {
        this.ruleForm = {
          name: "",
          responsiblePerson: "",
          mobileNo: "",
          belongEnterprise: "",
          warehouseArea: null,
          address: "",
          longitude: "",
          latitude: "",
          remark: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onGotLngLat(obj) {
      this.ruleForm.latitude = obj.lat;
      this.ruleForm.longitude = obj.lng;
    },
    search() {
      let id = this.query.id;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = '加载中...';
        warehouseDetail(id)
          .then(r => {
            r = r.data;
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //返回按钮
    onBack() {
      this.gotoupper();
      //this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm() {
      this.ruleForm = {
          name: "",
          responsiblePerson: "",
          mobileNo: "",
          belongEnterprise: "",
          warehouseArea: null,
          address: "",
          longitude: "",
          latitude: "",
          remark: ""
        };
      this.query.id = null;
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
      this.ruleForm.longitude = parseFloat(this.ruleForm.longitude);
      this.ruleForm.latitude = parseFloat(this.ruleForm.latitude);
      if (this.query.id == null || this.query.id == "") {
        this.loading = true;
        this.loadingText = '保存中...';
        warehouseSave(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "物资仓库保存";
            this.logInfo.LogMessage = r ? "物资仓库保存成功" : "物资仓库保存失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "物资仓库详情页面";
            this.addOperationLog();
            this.gotoupper();
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        warehouseUpdate(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "物资仓库修改";
            this.logInfo.LogMessage = r ? "物资仓库修改成功" : "物资仓库修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "物资仓库详情页面";
            this.addOperationLog();
            this.gotoupper();
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
        }
        else {
          console.error("error submit!!");
          return false;
        }
      })
      //this.$router.go(-1); //返回上一层
    },
    gotoupper() {
      this.$router
        .push({
          path: "/plugin/emergency/ui/MaterialWarehouselist",
          // name: 'mallList',
          query: {}
        })
        .catch(() => {});
    }
  }
};
</script>